import { render } from "./WinnerSlider.vue?vue&type=template&id=0af2d33e"
import script from "./WinnerSlider.vue?vue&type=script&lang=js"
export * from "./WinnerSlider.vue?vue&type=script&lang=js"

import "./WinnerSlider.vue?vue&type=style&index=0&id=0af2d33e&lang=css"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__